"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateType = void 0;
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _primitivePreview = _interopRequireDefault(require("../preview/primitivePreview"));
var _constants = require("./constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var OVERRIDABLE_FIELDS = [..._constants.DEFAULT_OVERRIDEABLE_FIELDS];
var DATE_CORE = {
  name: 'date',
  title: 'Datetime',
  type: null,
  jsonType: 'string'
};
var DateType = {
  get() {
    return DATE_CORE;
  },
  extend(subTypeDef) {
    var parsed = Object.assign((0, _pick2.default)(DATE_CORE, OVERRIDABLE_FIELDS), subTypeDef, {
      type: DATE_CORE,
      preview: _primitivePreview.default
    });
    return subtype(parsed);
    function subtype(parent) {
      return {
        get() {
          return parent;
        },
        extend: extensionDef => {
          var current = Object.assign({}, parent, (0, _pick2.default)(extensionDef, OVERRIDABLE_FIELDS), {
            type: parent
          });
          return subtype(current);
        }
      };
    }
  }
};
exports.DateType = DateType;